import { graphql } from "@opensea/graphql"

export const ActivityEventFragment = graphql(`
  fragment ActivityEvent on Activity {
    type
    from {
      address
    }
    to {
      address
    }
    ... on TraitOffer {
      traitIdentifiers {
        traitType
        value
      }
    }
  }
`)
